import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-premiere-pro/uxp-premiere-pro/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp-api-reference"
    }}>{`UXP API Reference`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "reference-js/index.md"
        }}>{`JavaScript Reference`}</a>{` : Technical documentation regarding the functions, classes, and modules available globally (on window, for example) and via `}<inlineCode parentName="li">{`require`}</inlineCode>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "reference-css/index.md"
        }}>{`CSS Reference`}</a>{` : Technical documentation regarding the kinds of CSS styles and features available in UXP.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "reference-html/index.md"
        }}>{`HTML Reference`}</a>{` : Technical documentation regarding some of the HTML elements and attributes that are supported.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "reference-spectrum/index.md"
        }}>{`Spectrum UXP Reference`}</a>{` : Information on the Spectrum UXP Widgets and Spectrum Web Components, and their capabilities.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "known-issues.md"
        }}>{`Known Issues`}</a>{`: List of known issues in UXP`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      